import {withKnownRoute} from '../../lib/routes';
import {SpeciePage} from './specie-page';

export default withKnownRoute(SpeciePage);
